import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericSimpleButton, GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';

const Header = (props) => {
    return (  
        <div className="row bottom-separator-xs">
            <div className="col-xs-6">
                <div className="row">
                    <div className="col-xs-5">
                        {(props.functions.Modificacion == true) &&
                            <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_PERFYPERM_EDICION")}>
                                <GenericSimpleButton
                                    text="Editar Permisos" 
                                    buttonClass="btn btn-cta" />
                            </Link>}
                    </div>
                    <div className="col-xs-7">
                        {(props.functions.Alta == true) &&
                            <GenericModalButton text="Nuevo perfil" dataTarget="#newProfileModal" buttonClass="btn btn-secondary" />}                            
                    </div>
                </div>
            </div>
            <div className="col-xs-6">
                <div className="col-xs-12">
                    {(props.functions.Modificacion == true) &&
                        <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_PERMISOS_MASIVOS")}>
                            <button type="button" className="btn btn-link">
                                Asignar permisos masivamente
                            </button>
                        </Link>}
                </div>
            </div>
        </div>
    );
}

export default Header;